import { render, staticRenderFns } from "./DownloadCeremony.vue?vue&type=template&id=9724f7f8"
import script from "./DownloadCeremony.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadCeremony.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports